var lib_core = require("lib-core");

var EnvironmentTesterView = require("./environmentTesterView.js");
var EnvironmentTesterModel = require("./environmentTesterModel.js");

var EnvironmentTesterController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(EnvironmentTesterController, lib_core.Controller);

module.exports = EnvironmentTesterController;

EnvironmentTesterController.prototype.createView = function () {
    return new EnvironmentTesterView(this.getModel());
};

EnvironmentTesterController.prototype.createModel = function () {
    return new EnvironmentTesterModel(this.configuration);
};
